import React from 'react'
import Form from "react-bootstrap/Form"
import PropTypes from 'prop-types'

import {Col} from "react-bootstrap"
import './InputDomicilio.css'

const InputDomicilioIntegranteOrgano = (props) => {
  const register = props.register

  const idElemento = controlId => props.controlId + controlId
  const elementoInvalido = props.elementoInvalido
  const elementoValido = props.elementoValido

  const agregarValidacion = (nombre) => {
    return {
      isInvalid: elementoInvalido(nombre, props.indice),
      isValid: elementoValido(nombre, props.indice),
      name: `integrante[${props.indice}].${nombre}`
    }
  }

  return (
    <div className='input-domicilio'>
      <Form.Row>
        <Col md={6}>
          <Form.Group controlId={idElemento('formCalle')}>
            <Form.Label>Calle</Form.Label>
            <Form.Control type="text"
              placeholder={'Calle'}
              ref={register({required: true})}
              {...agregarValidacion('calle')}
            />
            <Form.Control.Feedback type="invalid">
              Debe ingresar la calle
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Row>
            <Col md={6} >
              <Form.Group controlId={idElemento("formNumeroCalle")}>
                <Form.Label>Número</Form.Label>
                <Form.Control type="text"
                  placeholder={!props.disabled ? "Número": ''}
                  {...agregarValidacion('numeroCalle')}
                  ref={register({
                    required: true
                  })}
                />
                <Form.Control.Feedback type="invalid">
                  Debe ingresar el numero de la calle
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId={idElemento("formPiso")}>
                <Form.Label>Piso</Form.Label>
                <Form.Control type="text"
                  {...agregarValidacion('piso')}
                  placeholder={'Piso'}
                  ref={register({pattern: /^[\d]+$/, required: false})}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId={idElemento("formCodigoPostal")}>
                <Form.Label>CP</Form.Label>
                <Form.Control type="text"
                  {...agregarValidacion('codigoPostal')}
                  placeholder={!props.disabled ? "CP.": ''}
                  ref={register({pattern: /^[\d]+$/, required: false})}
                />
              </Form.Group>
            </Col>
          </Form.Row>
        </Col>
      </Form.Row>
    </div>
  )
}

InputDomicilioIntegranteOrgano.propTypes = {
  indice: PropTypes.number,
  elementoInvalido: PropTypes.func,
  elementoValido: PropTypes.func,
  watch: PropTypes.func,
  register: PropTypes.func
}

export default InputDomicilioIntegranteOrgano
